export default "__VITE_ASSET__bd1b553e__"